import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DripCampaignSingleCriteria from "./drip-campaign-single-criteria";
import { mapActions } from "vuex";
import { ADD_TRIGGER, SAVE_TRIGGER, SAVE_TRIGGER_ARGUMENT, DELETE_TRIGGER } from "../store/drip-campaign-actions";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignEditCriteria",
  components: {
    DripCampaignSingleCriteria
  },
  props: {
    automation: {
      type: Object,
      required: true
    },
    triggers: {
      type: Array,
      required: true
    },
    exitCriteria: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      i18nMapType: this.exitCriteria ? "editCriteriaExit" : "editCriteria"
    };
  },
  computed: {
    triggersToUse() {
      var _context;
      return _filterInstanceProperty(_context = this.triggers).call(_context, t => t.exit == this.exitCriteria);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DripCampaignStore", [ADD_TRIGGER, SAVE_TRIGGER, SAVE_TRIGGER_ARGUMENT, DELETE_TRIGGER])), {}, {
    handleAddCriteria() {
      const newTrigger = {
        type: "",
        metadata: {},
        exit: this.exitCriteria
      };
      this.ADD_TRIGGER({
        data: newTrigger
      });
    },
    handleTriggerChange(data, _localId) {
      let canChange = true;
      if (data.type === "client-profile-marked-active" || data.type === "client-profile-marked-inactive") {
        var _context2;
        canChange = !_findInstanceProperty(_context2 = this.triggers).call(_context2, trigger => trigger.type === data.type);
      }
      if (canChange) this.SAVE_TRIGGER({
        data,
        _localId
      });
    },
    handleArgumentChange(data, _localId) {
      this.SAVE_TRIGGER_ARGUMENT({
        data,
        _localId
      });
    },
    handleDeleteCriteria(_localId) {
      this.DELETE_TRIGGER({
        _localId
      });
    }
  })
});